declare var window: any;
declare var hj;

export default function hotjar(...args: any[]) {
  // https://help.hotjar.com/hc/en-us/articles/115015712548-Using-JavaScript-Triggers-to-Start-Recordings#example
  // tslint:disable only-arrow-functions
  window.hj =
    window.hj ||
    function() {
      (hj.q = hj.q || []).push(arguments);
    };
  window.hj(...args);
}
